import { render, staticRenderFns } from "./SubmitForm3.vue?vue&type=template&id=aa4021ce&scoped=true"
import script from "./SubmitForm3.vue?vue&type=script&lang=ts"
export * from "./SubmitForm3.vue?vue&type=script&lang=ts"
import style0 from "./SubmitForm3.vue?vue&type=style&index=0&id=aa4021ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4021ce",
  null
  
)

export default component.exports